import { gql } from 'urql'

export const GET_USER_ACCEPTED_COURSE_INVITES_WITH_SPLASH_SCREENS = gql`
  query GetUserAcceptedCourseInvitesCountWithSplashScreens($profileId: uuid!) {
    course_invites_aggregate(
      where: {
        status: { _eq: ACCEPTED }
        participant: { profile_id: { _eq: $profileId } }
      }
    ) {
      aggregate {
        count
      }
    }
    course_invite_splash_screens: submission_of_splash_screens(
      where: { splash_screen: { _eq: KNOWLEDGE_HUB_COURSE_INVITE } }
    ) {
      seen_count
    }
  }
`
